import styled from 'styled-components';
import {Button} from 'react-bootstrap';
import {tint} from 'theme/helper';

// The furniture the Drawer Layout card is built from, shared so the cabinet
// and the standalone drawer face panel cannot drift apart.

export const Card = styled.div`
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(20, 60, 110, 0.14);
    margin-bottom: 14px;
`;

export const CardHeader = styled.div`
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    padding: 11px 18px;
    border-bottom: 1px solid
        ${({theme}) => tint(theme.colors.primary?.main, 0.12)};
    background: ${({theme}) => tint(theme.colors.primary?.main, 0.05)};
    font-size: 15px;
    font-weight: 700;
    color: ${({theme}) => theme.colors.primary?.main};

    .more-info button {
        line-height: 0;
        transform: translateY(-1px);
    }
`;

export const Spacer = styled.div`
    flex: 1;
`;

export const ResetButton = styled(Button)`
    &&& {
        font-size: 0.8rem !important;

        img {
            width: 16px;
        }
    }
`;

export const InfoText = styled.span`
    display: inline-block;
    max-width: 260px;
`;

// the bar the pointer takes hold of on a face boundary
export const Grip = styled.span<{$dragging: boolean}>`
    display: block;
    width: ${({$dragging}) => ($dragging ? 96 : 62)}px;
    height: ${({$dragging}) => ($dragging ? 5 : 4)}px;
    border-radius: 3px;
    box-shadow: 0 0 0 2px #fff;
    background: ${({$dragging, theme}) =>
        $dragging
            ? theme.colors.primary?.main
            : tint(theme.colors.primary?.main, 0.55)};
`;

// the controls for the selected face, beside the drawing
export const Panel = styled.div`
    flex: 1 1 0;
    /* below its own content it would be squeezed and overflow the card
       sideways, so it takes a line of its own instead */
    min-width: 280px;
    border: 1px solid ${({theme}) => tint(theme.colors.primary?.main, 0.18)};
    border-radius: 6px;
    background: ${({theme}) => tint(theme.colors.primary?.main, 0.05)};
`;

export const Heading = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    font-weight: 700;
    color: ${({theme}) => theme.colors.primary?.main};
`;

export const Badge = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 4px;
    background: ${({theme}) => theme.colors.primary?.main};
    color: #fff;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

// the dimension line down the drawing's left, labelled with the height it spans
export const RAIL_WIDTH = 26;

export const Rail = styled.div`
    position: absolute;
    left: 0;
    width: ${RAIL_WIDTH}px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const RailEnd = styled.div`
    width: 100%;
    height: 1px;
    background: #9aa7b5;
`;

export const RailLine = styled.div`
    flex: 1;
    width: 1px;
    background: #9aa7b5;
`;

export const RailLabel = styled.div`
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    padding: 6px 0;
    color: #6b7480;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    font-variant-numeric: tabular-nums;
`;

// one drawer's controls in the panel; the others stay mounted, hidden
export const PanelBlock = styled.div`
    padding: 13px;

    &[hidden] {
        display: none;
    }

    /* FormGroup indents 10px, pushing fields out of line with the heading */
    > div:not(${Heading}) {
        padding-left: 0;
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    /* stack each field, label above the control, like the margins card */
    [class*='col-'] {
        flex: 0 0 100%;
        width: 100%;
        max-width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
`;
